import PersonsPage from '@/features/companies/[companyId]/persons/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/companies/$companySlug/persons')({
  component: PersonsPage,
})
